import PrefixPath from "../config/AppConfig";
export const BaseUrl  =  PrefixPath.API_BASE_URL;
export const BaseUrl1  = PrefixPath.API_BASE_URL;